module.exports = __webpack_public_path__ + "img/oms-favicon.a084fd0a.png";